'use client'

import { usePathname, useSearchParams } from 'next/navigation'

import { FILTER_KEY_URL_PARAMS } from '../../Filters.types'

import TimeFilterSheet from './TimeFilterSheet'
import TimeFilterDropdown from './TimeFilterDropdown'

// On desktop, we have a Radio Button for "All times"
export const ALL_TIME_FILTERS_VALUE = 'all'

interface Props {
  handleRouteChange: (newRoute: string) => void
}

const TimeFilter = ({ handleRouteChange }: Props) => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const params = new URLSearchParams(searchParams.toString())

  const selectedTime = params.get(FILTER_KEY_URL_PARAMS.START_TIME)

  const updateFilter = (filterOption: string) => {
    if (filterOption === ALL_TIME_FILTERS_VALUE) {
      return resetFilter()
    }
    params.set(FILTER_KEY_URL_PARAMS.START_TIME, filterOption)
    handleRouteChange(`${pathname}?${params.toString()}`)
  }

  const resetFilter = () => {
    params.delete(FILTER_KEY_URL_PARAMS.START_TIME)
    handleRouteChange(`${pathname}?${params.toString()}`)
  }

  return (
    <>
      <TimeFilterSheet selectedTime={selectedTime} updateFilter={updateFilter} resetFilter={resetFilter} />
      <TimeFilterDropdown selectedTime={selectedTime} updateFilter={updateFilter} />
    </>
  )
}

export default TimeFilter
